module.exports = __webpack_public_path__ + "cyprus.svg?ba67761156f0456a6b085555eb2b0387";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cyprus.svg
// module id = 146
// module chunks = 10